import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'

/**
 * The request function every generated API function calls (DEV-1699). It uses the shared axios
 * instance, so the auth and organization headers and the response interceptor still apply. It
 * returns the whole response, so a hook can read the status (for example a 207 or a 409).
 */
export const apiRequest = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<T>> =>
  axios.request<T>({
    ...config,
    ...options,
    baseURL: process.env.NEXT_PUBLIC_API_URL
  })
